import { css } from "styled-components";
import { BorderRadius } from "./logical.styled.js";
export const VerticalScroll = css`
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		background: ${({ theme  })=>theme.colors.grays.base};
		${BorderRadius({
    all: '8px'
})}
	}
	&::-webkit-scrollbar-track {
		background: ${({ theme  })=>theme.colors.grays.light};
	}
`;

//# sourceMappingURL=scroll.styled.js.map